<template>
  <div>
    <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>

        <!-- Start the code for this screen here -->
        <div
          id="employee"
          class="container-fluid menu-margin-top mr-sm-3 mr-lg-0"
          style="z-index:1;padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b v-if="!roleId">Add New Role</b>
                <b v-if="roleId">Edit Role</b>
              </span>
            </nav>
            <div class="col d-flex justify-content-end align-items-center">
              <span :style="msgcolor">{{message}}</span>
            </div>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center mt-3 pr-5 mr-5">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center ">
                <label id="lnamelaabel" class="col-form-label col-form-label-sm pr-3 ">Role Name</label>
              </div>
              <!--col end-->
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 pl-0"
              >
                <input name='roleName' type="text"
                  class="form-control input-sm" 
                  placeholder="Role Name"
                  data-vv-name="Role Name"
                  v-model="roleObj.roleName"
                  v-validate="'required'"
                  autocomplete="off">
                  <div v-if="errors.has('Role Name')" class="alert-danger"  >
                {{ errors.first('Role Name') }}
             </div>
              </div>
            </div>
            <!--row end-->
            <br />
            <center class="mb-2 ml-5">
              <button type="submit" @click="addRole()" class="btn btn-secondary">Save</button>&nbsp;&nbsp;&nbsp;
              <button
                type="submit"
                 @click="cancel()"
                class="btn btn-secondary"
              >Cancel</button>
            </center>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: "addEditRole",

data() {
  return {
    message: '',
    roleObj : {
        roleName: '',
        // roleId: '',
        },
    // roleIdError: '',
    roleNameError: '',
    isLoading: false,
    roleId: '',
    msgcolor: {
          color: 'black'
        }
  }
},

methods: {

validateRoleType() {
      if (this.roleObj.roleName === '') {
        this.roleNameError = "The Role name field is required.";
      } else {
        this.roleNameError = "";
      }
      // if (this.roleObj.roleId === '') {
      //   this.roleIdError = "The Role Id field is required.";
      // } else {
      //   this.roleIdError = "";
      // }
    },

addRole () {
  this.message = ''
  this.msgcolor.color = 'Black'
    // this.validateRoleType()
    // if (this.roleNameError == '' && this.roleIdError == '') {
      // if (this.roleNameError == '') {
        this.$validator.validateAll().then(() => {
          if (!this.errors.any()) {
        this.isLoading = true
        if(this.roleId) {
          httpcommon
        .put(`acl/roles/update/info`,{
          userRoleC: this.roleId,
          userRoleX: this.roleObj.roleName
        })
        .then(response=>{
        this.isLoading = false
        console.log('update',response)
        this.$router.push('/roleManagement')
        }).catch(error=>{
        this.isLoading = false
        this.message = error.response.data.message
        this.msgcolor.color = 'Red'
        this.errorslist.push(error)
        })
        } else {
        httpcommon
        .post(`/acl/roles/add`,{
          // userRoleC: this.roleObj.roleId,
          userRoleX: this.roleObj.roleName
        })
        .then(response=>{
        this.isLoading = false
        console.log('response',response)
        this.$router.push('/roleManagement')
        }).catch(error=>{
        this.isLoading = false
        console.log('error',error)
        this.message = error.response.data.message
        this.msgcolor.color = 'Red'
        // this.errorslist.push(error)
        })
      }
    } })
    // }
    
},
cancel () {
    this.$router.push('/roleManagement')
},
  
getRoleById: function (id) {
  this.isLoading = true
        httpcommon
        .get(`/acl/roles/detail?roleId=${id}` )
        .then(response=>{
        this.isLoading = false;
        // this.roleObj.roleId = response.data[0].userRoleC
        this.roleObj.roleName = response.data[0].userRoleX
        }).catch(error=>{
        this.isLoading = false
        this.errorslist.push(error)
        })
    },
    myFunction() {
      var elmnt = document.getElementById("height2");
      var elmnt1 = document.getElementById("height3");
      var txt = elmnt.offsetHeight;
      var width = elmnt.offsetWidth;
      var txt1 = elmnt1.offsetHeight;
      var ht = txt + txt1;
      $("#employee").css("margin-top", txt + txt1 + 3);
    },
    menuheight () {
      var elmnt = document.getElementById("height2");
      var txt = elmnt.offsetHeight;
      $('#height3').css('margin-top', txt)
    }
},
created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.roleId = this.$route.params.roleId
    if(this.roleId) this.getRoleById(this.roleId)
  },
  beforeDestroy () {
    // document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style scoped >
.searchBlock {
  background-color: #F2F9FF;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  width: 100%;
}
.searchBlock h3 {
  font-weight: 600;
  color: #000000;
  line-height: 37.24px;
}
.searchBlock label {
  font: 400;
  font-size: 14px;
  color: #1C1B1F;
}
.searchBlock input {
  font: 400;
  font-size: 16px;
  color: #1C1B1F;
  border: 1px solid #E4ECF4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
/* .searchBlock input::placeholder {
color: #C5C5C5;
} */
.searchBlock button {
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  background-color: #1E90FF;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  width: 100%;
}
.btncontainer {
  padding-top: 30px;
}
 button:disabled {
  background-color: #9B9B9B !important;
  /* color: #000000; */
  /* cursor: none; */
}
.tableContainer {
    width: 100%;
}
.tableContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tableContainer .mergeButton {
  background: #1E90FF ;
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  color: #FFFFFF;
  border: none;
  font-weight: 600;
  height: -webkit-fill-available;
}
/* .customerTable {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
  table-layout: fixed;
} */
.customerTable thead tr {
  color: #9B9B9B;
  font: 600 14px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
}
/* .customerTable thead tr th {
    border-top: none;
} */
/* .customerTable tbody tr td {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
} */
tbody tr {
  border-bottom: 1px solid #dbdbdb;
}
.customerTable .tableName {
  font-weight: 600;
  font-size: 16px;
}
.customerTable {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    line-height: 32px;
    table-layout:auto;
    width: 100%;
}
.customerTable thead tr th {
    border-top: none;
    white-space: nowrap; /* Prevent header text from wrapping */
}
.customerTable tbody tr td {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    white-space: nowrap; /* Prevent cell text from wrapping */
}
 .second {
  white-space:wrap !important;
  word-wrap: break-word !important; /* Break long words */
  word-break: break-word !important; /* Break long words */
  overflow-wrap: break-word !important; /* Ensure the text wraps within the column */
}
@media only screen and (max-width: 768px) {
    .customerTable {
        table-layout: auto; /* Allow table to adapt to screen width */
    }
}
.dark-border {
  border-top: 2px solid #1E90FF !important; /* Adjust thickness and color as needed */
}
.customPagination ::v-deep .page-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none ;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9B9B9B;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005DF1;
  border-radius: 8px;
  color: #FFFFFF;
}

.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton,.yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  /* margin: auto; */
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.notFound {
  display: flex;
  /* width: 100% !important; */
  text-align: center;
  margin: auto;
}
.navLinks {
    list-style: none;
    display: flex;
    padding-left: 0;
    justify-content: center;
}
.navLinks li {
    padding: 10px 35px 10px 0px;
}
.linkItem {
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
font-size: 18px;
font-weight: 600;
color: #8C8C8C;
Padding:10px 30px 10px 30px;
border-radius: 8px;
}
.linkItem:hover {
    color: #FFFFFF;
    background-color: #1E90FF;
}
.navLinks .active {
color: #FFFFFF !important;
background-color: #1E90FF;
}
.filterLabel {
  padding: 7px;
  margin: 0;
  margin-top: 6px;
  color: #1C1B1F;
  font-size: 14px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dropdownContainer {
  width: 100%;
}
@media only screen and (min-width: 1201px) {
.dropdownContainer {
  width: 90%;
}
}
.b-dropdown {
  width: 100%;
  height: 46px;
  max-height: 46px;
}
 .filterDropdown ::v-deep .dropdown-toggle  {
  border-radius: 8px !important;
  border-color: #BAC1C8;
  background-color: #FFFFFF !important;
  color: #8A8A8A;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: start;
  padding: 0px 0px 0px 12px;
}
.filterDropdown ::v-deep .dropdown-toggle::after {
  position: absolute;
  top: 20px;
  right: 13px;
}
.filterDropdown ::v-deep .dropdown-menu {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  min-width: 18rem !important;
  border: none;
  /* border-radius: 8px; */
  box-shadow: -4px 6px 25.6px 0px #00000021;
  padding: 12px 8px 12px 8px;
  z-index: 1;
}
.filterDropdown ::v-deep .custom-control {
padding: 16px 12px 16px 12px;
}
.filterDropdown ::v-deep .custom-control-input {
  position: relative;
}
/* .filterDropdown ::v-deep .custom-control:hover {
  background-color:#dbdbdb;
} */
.filterDropdown ::v-deep .custom-control-label {
  padding-left: 16px !important;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
}
.filterDropdown {
  width: 100%;
}

.dropdownToggle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}



.validationError {
  color: #EA2626;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 18.62px;
}
</style>